/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import qs from 'qs';
import useSWR from 'swr';

import type * as Type from '@/common/interface';
import request from '@/utils/request';

export const getAdminTagsSetting = () => {
  return request.get<Type.AdminTagsSetting>('/answer/admin/api/siteinfo/tag');
};

export const updateAdminTagsSetting = (params: Type.AdminTagsSetting) => {
  return request.put('/answer/admin/api/siteinfo/tag', params);
};

export const useTagSynonymCandidates = (
  params: Type.TagSynonymCandidateReq,
) => {
  const apiUrl = `/answer/admin/api/tag-synonym-candidates?${qs.stringify(
    params,
    {
      skipNulls: true,
    },
  )}`;
  const { data, error, mutate } = useSWR<
    Type.ListResult<Type.TagSynonymCandidateItem>,
    Error
  >([apiUrl], request.instance.get);
  return {
    data,
    isLoading: !data && !error,
    error,
    mutate,
  };
};

export const approveTagSynonymCandidate = (id: number, reviewNote = '') => {
  return request.post('/answer/admin/api/tag-synonym-candidates/approve', {
    id,
    review_note: reviewNote,
  });
};

export const rejectTagSynonymCandidate = (id: number, reviewNote = '') => {
  return request.post('/answer/admin/api/tag-synonym-candidates/reject', {
    id,
    review_note: reviewNote,
  });
};
